/*
  Shareable renderer for displaying the name of a synthetic test.
  Largely a copy/paste from the original table column.
*/
import React from 'react';
import { observer } from 'mobx-react';
import { Box, Link } from 'core/components';
import TestModel from 'app/stores/synthetics/TestModel';
import LabelList from 'app/components/labels/LabelList';

interface Props {
  model: TestModel;
  showLabels?: boolean;
}

function SynthTestNameRenderer({ model, showLabels = false }: Props) {
  const { collection } = model;
  // @ts-expect-error skipping type check
  const labelFilters = collection.discreteFilterValues.labelMultiSelect;

  return (
    <Box width="100%" overflow="hidden">
      <Link to={`/v4/synthetics/tests/${model.id}/results`} fontWeight="bold" display="block" ellipsis>
        {model.get('display_name')}
      </Link>
      {/* @ts-expect-error skipping type check */}
      {showLabels && <LabelList labels={model.labels} fixedWidth priorityLabels={labelFilters} />}
    </Box>
  );
}

export default observer(SynthTestNameRenderer);
